import Layout from '@layout/Index'

export const mapCommentFeedback = [
  {
    path: '/map-comment-feedback',
    component: Layout,

    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "MapCommentFeedbackTable" */ './pages/MapCommentFeedbackTable.vue'),
        name: '地图评价反馈',
        meta: {
          title: '地图评价反馈',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/map-comment-feedback/map-comment-feedback.route.js